import { LoopReducer } from 'redux-loop'

import AERData from 'aer-data/src/index'

import { Action, State } from './types'

export const initialState: State = {
  ENG: AERData.normalizedData.ENG.treasures,
  FR: AERData.normalizedData.FR.treasures,
  PL: AERData.normalizedData.PL.treasures,
  DE: AERData.normalizedData.DE.treasures,
}

export const Reducer: LoopReducer<State, Action> = (
  state: State = initialState,
  action: Action
) => {
  switch (action.type) {
    default: {
      return state
    }
  }
}
